import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mra_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * In-memory GET cache with TTL. Dedupe inflight requests and serve cached
 * responses to avoid pummelling the backend with the same calls across pages
 * (e.g. /public/pricing-info is fetched by multiple components on every route).
 */
const _cache = new Map(); // path -> { expiresAt, data }
const _inflight = new Map(); // path -> Promise

export async function apiGetCached(path, { ttlMs = 60_000, params } = {}) {
  const key = params ? `${path}?${new URLSearchParams(params).toString()}` : path;
  const now = Date.now();
  const hit = _cache.get(key);
  if (hit && hit.expiresAt > now) return hit.data;
  if (_inflight.has(key)) return _inflight.get(key);
  const p = api.get(path, { params }).then((r) => {
    _cache.set(key, { expiresAt: Date.now() + ttlMs, data: r.data });
    _inflight.delete(key);
    return r.data;
  }).catch((err) => {
    _inflight.delete(key);
    throw err;
  });
  _inflight.set(key, p);
  return p;
}
